import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v1/auth';
import { isDefined } from '../../../../utils/variables';

export class AuthService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}
  callbackMicrosoftSso(params: types.CallbackMicrosoftSsoParameters): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async signIn(params: types.SignInParameters): Promise<types.SignInResponse> {
    const { data } = await this.axios.post<types.SignInResponse>(`/v1/auth/signin/`, params.body);
    return data;
  }

  async signOut(params: types.SignOutParameters): Promise<void> {
    await this.axios.post<types.SignInResponse>(`/v1/auth/signout/`);
  }

  async determineAuthFlow(
    params: types.DetermineAuthFlowParameters,
  ): Promise<types.DetermineAuthenticationFlowResponse> {
    const { data } = await this.axios.get<types.DetermineAuthenticationFlowResponse>(
      `/v1/auth/flow`,
      { params: params.query },
    );

    return data;
  }

  redirectMicrosoftSso(): Promise<void> {
    throw new Error(
      'This is not to be called from the client. Set windows.location.href to "getMicrosoftRedirectUrl()" to redirect to Microsoft endpoint.',
    );
  }

  getMicrosoftRedirectUrl(params: types.RedirectMicrosoftSsoParameters) {
    const url = new URL(this.axios.getUri());
    const isAWSDomain = url.hostname.includes('amazonaws.com');
    url.pathname = `${isAWSDomain ? '/Prod' : ''}/v1/auth/redirect/microsoft/`;

    // Append query parameters to the URL
    if (isDefined(params.query)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.entries(params.query).forEach(([key, value]) => {
        if (isDefined(value)) {
          url.searchParams.append(key, String(value));
        }
      });
    }

    return url.toString();
  }

  async createAzureMapsAccessToken(
    params: types.CreateAzureMapsAccessTokenParameters,
  ): Promise<types.AzureMapsTokenResponse> {
    const { data } = await this.axios.get<types.AzureMapsTokenResponse>(
      `/v1/auth/azure-maps/token/`,
    );
    return data;
  }

  async getDomainPolicy(
    params: types.GetDomainPolicyParameters,
  ): Promise<types.DomainPolicyResponse> {
    const { data } = await this.axios.get<types.DomainPolicyResponse>(`/v1/auth/domain-policy`, {
      params: params.query,
    });
    return data;
  }
}
